// initial state
import * as base from './base.js'
const baseName = '/admin/system/work'
const sendbaseName = '/admin/system/send'
const trackbaseName = '/admin/system/track'
const evaluatebaseName = '/admin/system/evaluation'
const changebaseName = '/admin/system/transfer'
const typebaseName = '/admin/system/workType'


const workList = baseName + '/list'
const worksendList = sendbaseName + '/list'
const worktrackList = trackbaseName + '/list'
const workevaluateList = evaluatebaseName + '/list'
const workchangeList = changebaseName + '/list'
const workstate = baseName + '/state'
const workType = typebaseName + ''


const obj = base.setBaseUrl('', baseName)
const obj1 = base.setBaseUrl('send', sendbaseName)
const obj2 = base.setBaseUrl('track', trackbaseName)
const obj3 = base.setBaseUrl('evaluate', evaluatebaseName)
const obj4 = base.setBaseUrl('change', changebaseName)
const obj5 = base.setBaseUrl('workstate', baseName)
const obj6 = base.setBaseUrl('workType', workType)


const a = Object.assign(obj,obj1,obj2,obj3,obj4,obj5,obj6, { workList,worksendList,worktrackList,workevaluateList,workchangeList,workstate,workType })
export default a